import {
  flow, partialRight, keyBy, values,
} from 'lodash';
const lastUniqBy = iteratee => flow(
  partialRight(keyBy, iteratee),
  values
);
const lastUniqById = lastUniqBy('id');
const sortNumber = (arrayToSort, paramToSortBy) => arrayToSort.sort((a, b) => b[paramToSortBy] - a[paramToSortBy]);
const sortNumberByRating = arrayToSort => sortNumber(arrayToSort, 'rating');
const lastUniqByIdAndSortByRating = flow(lastUniqById, sortNumberByRating);
export {
  lastUniqBy,
  lastUniqById,
  sortNumber,
  sortNumberByRating,
  lastUniqByIdAndSortByRating,
};
